/**
 * @description Hook utilizado para realizar operações relacionadas às análises de local realizadas nos exames de local
 * @author Diego Sabino Amorim de Araújo
 * @file useAnaliseLocalService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import useRouter from 'utils/useRouter'

import actionTypes from 'utils/actionTypes'
import { useFetch } from './useFetch'

export const useSessionService = () => {
  const dispatch = useDispatch()
  const router = useRouter()
  const fetch = useFetch()

  const setSession = (data) => {
    dispatch({
      type: actionTypes.SESSION_LOGIN_SUCESSO,
      token: data.token,
      usuario: data.usuario,
    })
  }

  const setLocalStorage = (token) => {
    localStorage.setItem('@sigep/token', token)
  }

  const login = async ({ cpf, senha }) => await fetch.postOpenWithoutFeedback('/auth/autenticar/local/', { cpf, senha })

  const autenticar = async ({ cpf, senha }) => await fetch.postOpenWithoutFeedbackAutenticar('/auth/autenticar/local/', { cpf, senha })

  const logoutTokenExpirado = () => {
    dispatch(
      {
        type: actionTypes.SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO,
      },
      localStorage.removeItem('@sigep/token'),
      localStorage.removeItem('@sigep/state'),
      router.history.push(`/auth/login`)
    )
  }

  const renewSession = (data) => {
    dispatch({
      type: actionTypes.RENEW_SESSION_SUCESSO,
      token: data.token,
      usuario: data.usuario,
    })
  }

  const renewToken = () => {
    try {
      return fetch.postWithoutFeedback('/auth/redefinir')
    } catch (err) {
      return null
    }
  }

  const solicitarRedefinirSenha = async (payload, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosUsuario = {
        cpf: payload.values.cpf,
      }
      await fetch.postOpenWithoutRenewToken('/auth/senha/redefinir/solicitar', dadosUsuario)
      dispatch({
        type: actionTypes.SOLICITAR_REDEFINIR_SENHA_SUCESSO,
      })
    } catch (err) {
      dispatch({
        type: actionTypes.SOLICITAR_REDEFINIR_SENHA_ERROR,
      })
    } finally {
      if (setProcessando) setProcessando(true)
    }
  }

  const redefinirSenha = async (dados, token, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosUsuario = {
        ...dados,
        token,
      }
      await fetch.postOpen('/auth/senha/redefinir/nova/', dadosUsuario)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

    const redefinirSenhaAdmin = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.postOpen('/auth/admin/redefinir-senha/', dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const solicitarEmailUsuarioPendente = async (idUsuario, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.postOpen('/auth/usuariopendente/solicitaremail/', { idUsuario })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const validarUsuario = async (idUsuario, token, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosUsuario = {
        senha: dados.senha,
        setores: dados.setores ? dados.setores.map((setor) => setor.id) : null,
        token,
        idUsuario,
      }
      await fetch.postOpen('/auth/validarusuario', dadosUsuario)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return {
    setSession,
    setLocalStorage,
    login,
    logoutTokenExpirado,
    renewToken,
    renewSession,
    solicitarRedefinirSenha,
    redefinirSenha,
    redefinirSenhaAdmin,
    solicitarEmailUsuarioPendente,
    validarUsuario,
    autenticar,
  }
}
